export default {
    general: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
    },
    home: {
        motto: 'Dentist for children and adults with a compassionate, calm, and considerate approach and expertise.',
        doctorTitle: 'Doctor of Dental Medicine',
        sections: {
            booking: 'Making an appointment',
            workingHours: 'Working hours',
            team: 'Our Team',
            services: 'Services',
            googleReviews: 'Google Reviews',
            followUs: 'Follow us on',
        },
        moreAboutUs: 'More about us...',
        pricelist: 'Price List',
        contactForm: {
            title: 'Fill in the form',
            subtitle: ' and we will contact you soon!',
        },
        social: {
            facebookAriaLabel: 'Visit our Facebook profile',
            instagramAriaLabel: 'Visit our Instagram profile',
        },
    },
    workingHours: {
        mon: 'Mon',
        tueThu: 'Tue, Wed',
        wed: 'Thu',
        fri: 'Fri',
    },
    contactForm: {
        namePlaceholder: 'Name',
        emailPlaceholder: 'E-mail',
        messagePlaceholder: 'Tell us how we can help',
        send: 'Send',
        sent: 'Sent',
        sending: 'Sending…',
        successTitle: 'We have received your message!',
        successSubtitle: 'We will contact you soon!',
        errors: {
            nameRequired: 'Please enter your name',
            nameTooShort: 'Name is too short',
            nameTooLong: 'Name is too long',
            emailRequired: 'Please enter your e-mail',
            emailInvalid: 'Please enter a valid e-mail',
            emailTooShort: 'E-mail is too short',
            emailTooLong: 'E-mail is too long',
            messageRequired: 'Please enter a description',
            messageTooShort: 'Description is too short (at least 30 characters)',
            messageTooLong: 'Description is too long (max 5,000 characters)',
            sendFailed: 'Sending failed.\nPlease try again or call us at {phone}.',
        },
    },
    reviews: {
        reviewsCount: '{count} reviews',
        connectionError: 'Connection error.',
        writeReview: 'Add a review!',
        ratingUnit: 'Rating',
    },
    footer: {
        copyright: '© Sočutno zobozdravstvo d.o.o. {year}',
    },
    closedBanner: {
        text: 'We are away until',
        tomorrow: 'tomorrow',
        dayAfterTomorrow: 'the day after tomorrow',
    },
    article: {
        bookAppointment: 'Make an appointment for a check-up',
        back: 'Back',
    },
    services: {
        ortopanBold: 'Panoramic',
        ortopanSuffix: 'Radiography',
        parodontologiaPrefix: 'Laser',
        parodontologijaBold: 'Periodontology',
        endodontskoBold: 'Endodontic',
        endodontskiSuffix: 'Treatment',
        myobrace: 'Myobrace\u00ae',
        invisalign: 'Invisalign\u00ae',
        beljenjeBold: 'Teeth',
        beljenjeSuffix: 'Whitening',
        laskerskoBold: 'Laser',
        lasterskoSuffix: 'Treatment',
        frenulotomijaBold: 'Laser',
        frenulotomijaSuffix: 'Frenulotomy',
        protetikaBold: 'Dental Bridges',
        protetikaSuffix: '& Crowns',
        preglediPrefix: 'Dental',
        preglediBold: 'Check-ups',
        otroskoBold: 'Dental Care',
        otroskoSuffix: 'for Children',
        kariesPrefix: 'Caries',
        kariesa: 'Treatment',
        injekcijskaTehnikaBold: 'Injection',
        injekcijskaTehnikaSuffix: 'Technique',
    },
    ekipa: {
        urska: {
            name: 'Urška Šavli',
            title: 'Doctor of Dental Medicine',
            quote: 'She loves working with people, chatting with patients, and is proud of everyone who overcomes their fear at Sočutno zobozdravstvo.',
        },
        katja: {
            name: 'Katja Cerar',
            title: 'Registered Nurse',
            quote: 'During procedures she checks whether the patient is comfortable, whether they have any doubts or concerns, and encourages them. She knows the best tricks to stop water running down your throat during treatments. Literally!',
        },
    },
    articles: {
        pregledi: {
            title: 'Dental Check-Ups',
            intro: 'We examine the teeth, periodontal tissues, and the whole mouth. We pay special attention to caries (tooth decay) and gum inflammation (periodontitis). Magnifying loupes allow us to get a particularly precise view and better diagnostics.',
            childrenTitle: 'Check-Ups for Children',
            childrenP1:
                'For children, we recommend a first check-up at the age of one year, when the teeth are examined for the first time, and we discuss hygiene, diet, and supplements with the parents. We answer common questions and share with parents proven methods to make brushing easier and their children more cooperative.',
            childrenP2:
                "We don't force children to be examined; we adapt to their mood and pace to make the experience enjoyable so that they come back feeling better next time. After the check-up, a small reward for encouragement and courage awaits the child.",
            childrenP3: 'For children, we recommend six-monthly preventive check-ups.',
            adultsTitle: 'Check-Ups for Adults',
            adultsP1:
                'When examining adults, we look for signs of <b>cancer</b> or <b>ulceration</b> in the oral cavity, we check <b>the development of the jaw</b>, and look for wrong or <b>harmful habits</b>.',
            adultsP2ParodontalDisease: 'Periodontal disease',
            adultsP2body:
                "is a very insidious disease that doesn't hurt and doesn't show clear signs until the teeth are already weak, by which time it's too late for successful treatment. We pay special attention to examining the periodontal tissues by measuring the pockets and checking for the presence of bleeding. If detected in the early stages, the disease can be successfully stopped and controlled.",
            adultsP3Xray: 'An X-ray of all your teeth—PANORAMIC RADIOGRAPHY',
            adultsP3body: 'is a great help for a thorough diagnosis and detection of problems.',
            cenikPre: 'You can check the prices of dental check-ups in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        karies: {
            title: 'Caries Treatment',
            intro: 'Caries or tooth decay is caused by oral bacteria that are "fed" too much sugar and because our saliva does not have a strong enough defence. Several factors are involved in the formation of caries.',
            preventivaTitle: 'Prevention',
            preventivaP:
                'We have a lot of bacteria in our mouths, which we successfully remove by regular and precise <b>brushing</b> and consistent <b>cleaning of the interdental spaces</b> with dental floss or interdental brushes. We try to <b>limit our sugar intake</b> and reduce its frequency. Sweetened coffee, juice, and flavoured water also count as sugar intake, and sweets, which are known to destroy teeth, are particularly high in sugar.',
            zascitaTitle: 'Protection',
            zascitaP:
                '<b>Saliva is also an important protection against caries</b> because it works by rinsing the teeth, removing sugar, killing bacteria, and strengthening the teeth with the minerals that are naturally present in saliva. Drinking enough water is very important to ensure that you have enough saliva. Salivary minerals can be replaced with special preparations (coatings), which are also available at our practice. Most often, we recommend GC MI Paste Plus.',
            zdravljenjeTitle: 'Treatment',
            zdravljenjeP1:
                "<b>Dentists don't actually cure caries</b>. Fillings are substitutes for teeth, which help prevent the caries from progressing in that area and allow the tooth to keep its shape and function. <b>The best filling is the one that doesn't exist.</b> However, we try to make the restoration as similar as possible to the natural tooth, so that the final filling looks like a healthy tooth and has similar mechanical and physical properties. <b>We use modern composite materials</b> that are safe, reliable, tested, and among those of the highest quality.",
            zdravljenjeP2:
                'Occasionally, due to oral conditions or special requirements, we use glass ionomer fillings, which have the advantage of stopping caries and adhering extremely strongly to the tooth.',
            zdravljenjeP3_1: 'In our clinic, we place great emphasis on hygiene, awareness, and ',
            zdravljenjeP3_2: 'prevention',
            zdravljenjeP3_3:
                ', because we believe that true health is the absence of disease, and that means the absence of caries.',
            cenikPre: 'You can check the prices of check-ups and fillings in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        ortopan: {
            title: 'Panoramic Radiography',
            infoPanelBold: 'Panoramic tomography',
            infoPanelBody:
                'is a basic diagnostic X-ray that allows us to examine teeth, bones, periodontal tissues, sinuses, nasal cavity, and surrounding structures.',
            intro: 'Panoramic radiography is done in a special lead-insulated room to protect the people around us, as panoramic radiography emits X-rays that allow us to see through tissues.',
            potekTitle: 'Exam Process',
            potekP1:
                'For the exam, you bite into a special guiding device, rest your chin on a shelf, hold the handles with your hands, and move your feet slightly forward. During the 12-second x-ray procedure, you have to be completely still and not move, so we can get a clear image. Our modern machine emits a minimal amount of radiation, approximately',
            potekRadiation:
                '7 microSv, which is 22 times less than you get if you smoke a pack and a half of cigarettes every day for a year.',
            priporocilTitle: 'Recommendations',
            priporocilP1: 'Panoramic radiography is',
            priporocilSafe: 'safe and recommended every two years for adults and children',
            priporocilP2:
                'over 8 years of age. We will email the radiography image to you and your dentist. If you so wish, we can put the recording onto a USB stick.',
            cenikPre: 'You can check the prices of X-rays in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        beljenje: {
            title: 'Teeth Whitening',
            intro: 'In our clinic, we provide <b>three types of whitening</b>. For all three, we use tried, tested, and safe products from the American manufacturer Ultradent. Whitening brings back the freshness and youthful appearance of teeth, but it does not achieve the whiteness of a toilet bowl, as some people imagine.',
            clinicalP: 'Cases from our clinical practice:',
            beforeLabel: 'Before therapy',
            afterLabel: 'After therapy',
            inOfficeTitle: 'In-office Whitening',
            inOfficeP1:
                "<b>In-office whitening</b> is the fastest, with noticeable results within an hour and a half. Before whitening, soft and hard plaque is cleaned, and then a particularly gentle and comfortable lip opener is inserted into the mouth to protect the soft tissues. We coat the gums with a turquoise gel and apply a red whitening gel to the teeth twice, 20 minutes each. After the time is up, we rinse off the gel, remove the protection, and you'll glow with a new, refreshed smile.",
            inOfficeWarning:
                '<b>WARNING</b>: Whitening does not affect the colour of coatings and fillings and is suitable for patients who have healthy gums and relatively few dental restorations.',
            customTrayTitle: 'Whitening With an Individual Splint',
            customTrayP:
                '<b>Whitening with an individual splint</b> is done in two visits, during the first of which we clean the soft and hard plaque from the teeth and take an impression. The dental technician creates an individual whitening splint based on the model of your teeth, which you pick up with the whitening syringes and instructions on your second visit. Whitening is done at home; it takes 8-10 hours. Again, you can use all the syringes one after the other, or you can use some of them later.',
            takehomeTitle: 'Whitening at Home With Ready-Made Splints',
            takehomeP:
                '<b>Whitening at home with ready-made splints</b> takes an hour and a half. The whitening package includes a visit during which we remove tartar, polish your teeth, and give you ten sets of splints (for the upper and lower jaw) to take home. If you wish, you can use all 10 splints on consecutive days or use only 5 and save the rest for later.',
            cenikPre: 'You can see the price of whitening services in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        parodontologija: {
            title: 'Periodontology',
            intro1: 'The health of your gums, mouth, and teeth is directly linked to the health of your whole body.',
            introWarning: 'Bleeding gums when brushing or flossing are a warning sign.',
            intro2body: 'Bleeding in the mouth is never normal and should not be taken lightly.',
            napredovanaTitle: 'Advanced Periodontal Disease',
            napredovanaP1:
                'Did you know that in advanced periodontal disease, the total surface area of the periodontal pockets reaches the size of the palm of the hand?',
            napredovanaP2Bold: 'Imagine you had a palm-sized festering wound somewhere on your body',
            napredovanaP2body:
                'You would probably seek help quickly. But this infected wound in the mouth does not hurt, is not visible, and is often ignored. Although it is far from the eyes, it is not far from the heart.',
            napredovanaP3:
                'Bacteria from deep periodontal pockets travel throughout the body and cause constant inflammation.',
            listTitle: 'Bacteria from periodontal pockets trigger inflammation throughout the body:',
            listItem1: 'they have an impact on the worsening of diabetes',
            listItem2: 'they increase the risk of lung disease and respiratory infections',
            listItem3: 'they worsen atherosclerosis',
            listItem4: 'they contribute to preterm labour in pregnant women and low birth weight in newborns',
            listItem5:
                "bacterial toxins from periodontal wounds have even been found in plaques in Alzheimer's disease",
            kajLahkoTitle: 'What Can We Do?',
            kajLahkoPre:
                'It is therefore important to regularly monitor your gums to make sure they are healthy. This is done by measuring the periodontal pockets with a special rounded-tip probe, examining the bleeding of the gums, and assessing bone retraction with ',
            kajLahkoXray: 'x-ray imaging',
            kajLahkoPost: '.',
            potekTitle: 'Treatment Course',
            potekP1:
                'To treat periodontal disease, we use an ultrasonic cleaner with dedicated tips that are both effective and gentle.',
            potekP2pre: 'Precise removal of the plaque above and below the gum is also achieved with a ',
            potekManual: 'hand-held root scaler',
            potekP2post: '.',
            laserTitle: 'Laser Treatment',
            laserP1pre: 'We place special emphasis on ',
            laserText: 'laser treatment',
            laserP1body:
                ', which uses a proven treatment protocol to provide an even more thorough disinfection of the periodontal pockets and excellent tissue regeneration. The treatment is performed under local anaesthesia, lasts approximately one hour, is painless, and the recovery is fast. Half of the mouth is treated at a time, and the other half after 2–3 weeks. Patients are pain-free after the procedure and can eat normal food the next day.',
            laserP2:
                'For support during treatment, we offer mouthwashes and specialised medication, as well as all the necessary accessories (special toothbrushes, interdental brushes).',
            cenikPre: 'You can check the prices of periodontal and laser services in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        otrosko: {
            title: 'Dental Care for Children',
            gradimoCeTitle: 'Building Trust',
            gradimoP1:
                'Dental care for children is an important mission for our practice. We want to present <b>going to the dentist as a pleasant experience</b> in a way that is tailored to the child, inclusive, and considerate, helping to promote their health and a healthy attitude toward dental care in the long term. We make more time for children and adapt to their developmental stage and response. ',
            gradimoP2:
                'Our rule is <b>not to force</b> procedures and to first explain and show the procedures to the child, and only carry them out after the child permits us to do so. This approach sometimes requires more visits, but is more successful in the long run, as it <b>builds a relationship of trust and respect</b> with the child.',
            ortodontTitle: 'Orthodontic Treatment',
            ortodontP:
                'At each check-up, we pay attention to the cleanliness of the teeth, discuss hygiene, diet, and drinks, check for any abnormalities in development, and warn if orthodontic treatment may be needed. We pay particular attention to <b>functional abnormalities</b>, e.g. breathing through the mouth, open-mouth posture, swallowing incorrectly, thumb sucking or using a pacifier for too long. These habits have an important influence on the development of the jaw and are quite easy to correct at an early stage with the ',
            cenikPre: 'You can check the prices of procedures and check-ups in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        myobrace: {
            title: 'Myobrace',
            infoPanelBold: 'Myobrace',
            infoPanelBody: 'is a therapy that corrects the causes of orthodontic abnormalities.',
            intro: 'By using Myobrace and doing exercises, we can correct the following in children at an early age:',
            wrongList: [
                'breathing through the mouth',
                'incorrect swallowing',
                'incorrect tongue position',
                'using a pacifier for too long',
                'sucking a finger for too long',
            ],
            correctTitleBold: 'During Myobrace therapy, we teach your child the right habits',
            correctList: [
                'tongue against the roof of the mouth',
                'swallowing correctly without letting the tongue slip out',
                'breathing through the nose',
            ],
            resultTitleBold: 'When we break bad habits, the jaws start to develop more properly',
            resultTitleSuffix: 'ensuring',
            resultList: [
                'a more regular facial development',
                'a lower chance of breathing and respiratory problems',
                'fewer caries',
                'aligned teeth',
            ],
            clinicalTitle: 'Clinical Cases',
            clinicalP: 'Cases from our clinical practice:',
            beforeTherapy: 'Before therapy',
            afterTherapy: 'After therapy',
            whenTitle: 'When to Start?',
            whenP1: 'Compared to conventional orthodontics, Myobrace is interesting from the point of view that',
            whenP2: '<b>it corrects the causes of orthodontic abnormalities and not only the consequences.</b> It is particularly effective if we start early enough. In our experience, <b>the age of around 7 to 8 years</b> has proven to be ideal. During this period, children are mature enough to wear the appliance for a sufficient amount of time and understand the exercises, but they still have a few years of development ahead of them.',
            therapyTitle: 'Therapy Course',
            therapyP1pre: 'Therapy is carried out in',
            therapySixVisits: 'six visits',
            therapyP2:
                'At the first visit, we use a myofunctional questionnaire to assess which abnormalities are present and what is showing in the development, and we take photographs of the initial state.',
            therapyP3:
                'There are 5 monthly check-ups to check progress and cooperation, and every month the child receives a new myofunctional exercise.',
            therapyP4:
                'At the end of the first therapy set, we take a picture of the condition of the teeth again and make a collage of the before-and-after state. If we see progress and changes in the teeth, we decide to go to the second stage of therapy, where the main goal is to widen the upper jaw.',
            therapyP5: 'Again, there are 6 check-ups and a final assessment.',
            therapyResults:
                'Therapy in children already shows <b>results after 6 months</b>, which parents also notice.',
            cenikPre: 'You can check the price of the Myobrace appliance in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        invisalign: {
            title: 'Invisalign',
            intro1: "<b>Invisalign is the world's most sophisticated and respected teeth aligner system</b>, trusted by over 16 million people. <b>These are transparent appliances that are almost invisible when worn</b> and eliminate crowding or gaps between teeth.",
            intro2: 'We use state-of-the-art digital tooth impression (scanning) to make the appliance, so no impression spoons or a triggered gag reflex. After scanning your teeth, we show you a simulation of your new smile, give you a detailed treatment plan, and set the duration of the treatment. We approve the design together, and 3D printers print your set of aligners.',
            benefit1Bold:
                "The treatment is quick, painless, doesn't interfere with your daily routine, and you can easily remove the appliance from your teeth to eat.",
            benefit2:
                'You get a specific number of splints for the specific number of weeks, tailored to you, each with a completely different job to do. The appliance must be worn for most of the day, 20–22 hours a day, and can only be removed while eating and brushing your teeth.',
            clinicalTitle: 'Clinical cases',
            clinicalP: 'Cases from our clinical practice:',
            beforeTherapy: 'Before therapy',
            afterTherapy: 'After therapy',
            goldTitlePre: '',
            goldTitleBold: 'A Gold Invisalign Provider',
            goldP1pre:
                'In 2023, Sočutno zobozdravstvo became one of the few dental practices in Slovenia to be awarded the ',
            goldP1Bold: 'GOLD Invisalign Provider',
            goldP2: 'We received the designation in a record one year of operation!',
            goldP3: 'The award criteria are professionalism, experience, and the number of successful cases.',
            priceTitlePre: 'Invisalign Price',
            priceTitleBold: 'How much do Invisalign invisible braces cost?',
            pricePre:
                'We offer packages from 7 to 20 weeks, depending on the difficulty level and individual preferences. <br />The price of Invisalign appliances depends on the number of splints. Find out more in the',
            priceCenikPre: ' ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        lasersko: {
            title: 'Laser Dentistry',
            p1: 'Lasers are excellent at removing bacteria in <b>tooth canals</b>, which is particularly important in the case of long-term canal infections (gangrene). After laser disinfection of the canal, the tooth is more likely to heal successfully and stay in the mouth longer.',
            kirurgijaTitle: 'Surgery',
            kirurgijaP:
                'The laser is used to cut or <b>reshape gums</b> or tissues in the mouth <b>almost painlessly</b>. After the laser procedure, conventional surgical suturing is not necessary as the tissue has "closed" edges and there is no bleeding.',
            beljenjeTitle: 'Teeth Whitening',
            beljenjeP:
                'In <b>teeth whitening</b>, we activate the gel with a laser, which shortens the whitening time and increases the whitening efficiency.',
            parodontTitle: 'Treatment of Periodontal Disease',
            parodontP:
                'In our dental practice, we use a laser for effective treatment and as an aid in solving many problems. It is most effective in the treatment of <b>periodontal disease</b>. In addition to sonic and manual pocket cleaning, we use the latest advances in treatment and also disinfect the pockets with a laser. After cleaning, a liquid, which foams and further disinfects the ducts, is added to the pockets. This cleans the periodontal pockets thoroughly and disinfects them even in places where we are not thorough enough with the tip of the instruments. <b>In the long term, combined laser treatment is much more successful than treatment with mechanical methods alone.</b>',
            cenikTitleBold: 'Laser Dentistry—Price',
            cenikPre: 'You can see the price of laser procedures in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        frenulotomija: {
            title: 'Laser Frenulotomy',
            infoPanelBold: 'Frenulotomy',
            infoPanelBody: 'is a procedure in which the too-short ligaments in the mouth are cut.',
            vezListTitle: 'There are several ligaments in the mouth:',
            vezList: ['tongue frenulum', 'upper lip frenulum', 'lower lip frenulum', 'cheek frenulum'],
            podjezicnaTitle: 'Short Tongue Frenulum',
            podjezicnaP1:
                '<b>The tongue frenulum</b>, which restricts the movement of the tongue, <b>causes the most problems.</b> This can lead to problems as early as infancy or later in development.',
            podjezicnaP2Bold: 'A tongue frenulum that is too short can lead to many problems.',
            dojenckiListTitle: 'Problems in infants:',
            dojenckiList: [
                'problems with breastfeeding and weight gain',
                'poor suction reflex',
                'capturing too little of the breast, causing the mother severe pain and sores on the nipple',
            ],
            otrokListTitle: 'Problems in children:',
            otrokList: [
                'speech difficulties: especially with the letters R and L',
                'eating problems: children eat slowly, "push" food into their cheeks, are picky, cannot tolerate solid food, stop and use their fingers to help themselves, often get food stuck, or food gets in their windpipe',
            ],
            podjezicnaP3:
                'If, upon examination, the child is found to have a short tongue frenulum and at least some of these problems are present, a <b>frenulotomy</b> is advised.',
            podjezicnaP4:
                '<b>Even in preschool and school children</b>, a frenulotomy is advised if a short tongue frenulum and at least some of these symptoms are observed.',
            zgornjaTitel: 'Short Upper Lip Frenulum',
            zgornjaiP:
                'A short upper lip frenulum can cause problems due to the limited mobility of the upper lip:',
            zgornjaListTitle: 'Problems due to a short upper lip frenulum:',
            zgornjaList: ['food getting stuck under the lip', 'poor teeth brushing', 'spacing between teeth'],
            potekTitle: 'Procedure Course',
            potekP1:
                'Before each procedure, we thoroughly discuss the observed problems with the parents, examine the child carefully, and give you instructions on post-procedure care and exercises.',
            potekP2Bold: 'At our practice, the procedure is performed using a laser.',
            potekP2body:
                'It is a safe, quick, and almost painless procedure. The parents are present during the procedure, and the infant can be comforted and fed immediately after the procedure.',
            cenikTitlePre: 'Frenulotomy Price',
            cenikTitleBold: 'How much does tongue frenulotomy cost?',
            cenikPre: 'You can see the price of frenulotomy in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        protetika: {
            title: 'Dental Crowns & Bridges',
            mosticekTitle: 'Dental Bridge',
            mosticekP1:
                'When a tooth is missing from the mouth, it needs to be replaced. This restores the ability to successfully bite, chew, balance muscles and chewing joints, as well as aesthetics.',
            mosticekInfoBold: 'A dental bridge',
            mosticekInfoBody:
                'is a fixed prosthetic product that is cemented to adjacent teeth and cannot be removed.',
            mosticekP2pre:
                'We use the dental bridge to compensate for shorter gaps. As a rule, two teeth are ground down to ',
            mosticekReplace: 'replace one or two missing teeth',
            mosticekP2post:
                '. The supporting teeth are the "abutments" that support the missing tooth—the "bridge".',
            prevlekeTitle: 'Dental Caps—Crowns',
            prevlekeP1pre: 'After ',
            prevlekeEndo: 'endodontic treatment',
            prevlekeP1post:
                ', for very weakened, damaged, stained, or destroyed teeth, we opt for a cap or crown.',
            prevlekeP2pre: 'You can choose from ',
            prevlekeMetalCeramic: 'metal-ceramic',
            prevlekeP2mid1: ', ',
            prevlekeFullCeramic: 'full ceramic',
            prevlekeP2mid2: ', or ',
            prevlekeZirconia: 'zirconia',
            prevlekeP2post:
                ' crowns. We make space and shape the tooth so that the dental technician can create a new, more beautiful, and more functional restoration.',
            luskeTitle: 'Dental Veneers',
            luskeInfoBold: 'Dental Veneers',
            luskeInfoBody:
                'are thin shells on the front of the teeth that are used to partially change the colour, shape, or inclination of the tooth.',
            luskeP1: 'This requires only minimal grinding of the tooth and can sometimes even be avoided.',
            luskeP2pre: 'The veneers are made from ',
            luskeZirconia: 'zirconia',
            luskeP2post: ' and really brighten up the appearance of teeth.',
            luskeP3: 'They are suitable for mostly healthy teeth, without major staining or fillings.',
            materialiTitle: 'Materials',
            materialiIntro: 'We have a choice of gap-filling materials.',
            materialiMetalCeramicBold: 'Metal ceramic',
            materialiMetalCeramicBody:
                'is suitable for teeth in the back of the mouth that experience high chewing forces. The toughness of the metal is combined with the aesthetics of the ceramic, which is coated over the entire prosthetic part, so the metal is not visible on the outside.',
            materialiFullCeramicBold: 'Full ceramic',
            materialiFullCeramicBody:
                'is used on anterior teeth, where we mainly want a beautiful appearance and the high strength that ceramic offers.',
            materialiZirconiaBold: 'Zirconia',
            materialiZirconiaBody:
                'is a newer material with an even stronger structure, which has recently become very popular in our country for replacing front teeth, as it most closely mimics the appearance of natural teeth.',
            cenikPre: 'You can see the prices of individual prosthetic solutions in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        injekcijskaTehnika: {
            title: 'Injection Technique',
            introP1: 'An unusual name for a procedure that can completely change your smile.',
            introP2:
                'With the injection technique, we apply a layer of composite material to your teeth without any drilling, changing their shape, size, or partly their colour. It is a specialised liquid composite (a filling material) made by the Japanese manufacturer GC.',
            infoBold: 'The injection technique',
            infoBody:
                'is bonding with liquid composite, applied without drilling through a transparent template (a silicone key).',
            introP3: 'Three visits are needed to complete the treatment.',
            potekTitle: 'How the treatment proceeds',
            obisk1Title: 'Visit 1 – scanning and planning',
            obisk1P:
                'At the first visit, we scan your teeth – taking a digital impression and photographing your face. The dental technician then designs your new smile, 3D-prints a model of your new teeth, and prepares a transparent template.',
            obisk2Title: 'Visit 2 – applying the composite',
            obisk2P1:
                'At the second visit, we prepare your teeth for the material, protect the adjacent teeth, apply an adhesive, and inject the composite paste into the template. It is this use of a syringe with liquid composite that gives the technique its name.',
            obisk2P2:
                'We shine a blue curing light through the transparent template, which hardens the material and bonds it to the teeth. Excess material is then removed, followed by polishing and final finishing, after which the teeth look naturally glossy and blend in with the neighbouring ones.',
            obisk3Title: 'Visit 3 – follow-up check',
            obisk3P:
                'A month later, we carry out a follow-up check. At this visit, we correct any minor imperfections, such as remaining rough surfaces, assess your bite, and discuss your experience over the past month. We also take final photographs.',
            clinicalTitle: 'Clinical case',
            clinicalP: 'An example from our own practice:',
            beforeTherapy: 'Before treatment',
            afterTherapy: 'After treatment',
            prednostiTitle: 'Advantages of the injection technique',
            prednostiList: [
                'we do not touch the teeth, grind them, or remove any tooth substance',
                'the procedure is relatively quick',
                'the procedure is completely painless',
                'the result is fast and aesthetic',
                'because the teeth are designed by a dental technician in the laboratory, they all have an ideal shape and correct contacts with neighbouring teeth, which in the long run allows for successful cleaning and healthy gums; the technician also plans the bite, so the restoration lasts and does not chip',
                'you can see the final result before the procedure even begins',
                'corrections are simple, as we keep your template and reuse it whenever needed',
                'the appearance is natural',
            ],
            primernaTitle: 'When the injection technique is suitable',
            primernaList: [
                'when we want to change the shape and size of the teeth',
                'to close diastemas (small gaps) between the teeth',
                'to rebuild worn or damaged teeth',
                'to even out the length or size of the front teeth (e.g. upper lateral incisors that are too small on one or both sides)',
            ],
            cenikPre: 'You can check the price of the injection technique in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        endodontsko: {
            title: 'Endodontic Treatment',
            introPre:
                "Have you heard of a granuloma or a dead tooth? Have you ever had an extremely bad toothache that kept you awake? Doesn't sound very pleasant, does it? In all these cases, the treatment is similar. We call it ",
            introBold: 'endodontic treatment',
            introPost: 'or root canal treatment.',
            potekTitle: 'Treatment Course',
            potekP1:
                'In this treatment, we remove dead cells, remnants of blood vessels and nerves, as well as bacteria and root canals that are present in each tooth root. Removal is mechanical, with hand-held, modern, and reliable machine needles and files, and chemical, with safe but effective solutions.',
            potekP2pre:
                'The biggest challenge in endodontic treatment is good visibility, which is achieved by ',
            potekP2Bold: 'using magnifying loupes with strong light',
            potekP2post: '.',
            potekP3Bold: 'After the first cleaning of the canals, we put in the "medicine"',
            potekP3body:
                ', which is a special paste with a high pH (strong base) that further disinfects the canals and allows the body to fight off the bacterial infection. We will temporarily close the tooth and make an appointment for you in about 3 weeks.',
            potekP4pre:
                'If you have had no problems during these 3 weeks, if the tooth is not sensitive and there is no more odour, it can be filled for the final time. ',
            potekP4Bold: 'A tooth like this can stay in your mouth for many years',
            potekP4post:
                ", but you won't feel heat, cold, or pain in it. If the crown is well preserved, we check the success of the treatment with an X-ray and then make the final filling.",
            potekP5Bold: 'If a large part of the tooth is missing, it is reinforced with a crown',
            potekP5post:
                'or an endocrown to ensure a good seal and strength, and thus the longevity of the tooth.',
            cenikPre: 'You can check the price of endodontic treatment in the ',
            cenikLinkText: 'Price List',
            cenikPost: '.',
        },
        onas: {
            title: 'About Us',
            urska: {
                name: 'Urška Šavli',
                title: 'Doctor of Dental Medicine',
                poklicnoTitle: 'Professional',
                poklicnoP1: 'Dentist with more than 10 years of work experience in dentistry.',
                poklicnoP2:
                    'She graduated in 2013 at the University of Ljubljana and obtained the title of Doctor of Dental Medicine.',
                quote: 'She loves working with people, chatting with patients, and is proud of everyone who overcomes their fear at Sočutno zobozdravstvo.',
                poklicnoP3:
                    'She regularly attends dental seminars at home and abroad. She is particularly passionate about myofunctional therapy, invisible aligners and is interested in sublingual ligaments and their effect on facial development.',
                osebnoTitle: 'Personal',
                osebnoP1:
                    'She is a wife, mother of three school-age children, two boys and a girl, originally from Ljubljana, a Bela Krajina soul.',
                osebnoP2:
                    'In her spare time she enjoys reading fiction and professional literature in the natural sciences, and is also interested in art history.',
                osebnoP3: 'She has completely healthy teeth, without a single filling.',
                zanimivostiTitle: '3 fun facts',
                zanimivosti1:
                    'Urška does not like small lego bricks and has no good ideas what to build from them.',
                zanimivosti2:
                    'She loves travelling, excursions and holidays with children. Favourite: London in June 2025.',
                zanimivosti3: 'She has never done a headstand in her life.',
            },
            katja: {
                name: 'Katja Cerar',
                title: 'Registered Nurse',
                poklicnoTitle: 'Professional',
                poklicnoP1:
                    'Registered nurse Katja is the first voice you hear when you call us. She charms everyone with patience, friendliness and helpfulness.',
                poklicnoP2: 'She graduated with distinction in 2016 at the University of Ljubljana.',
                poklicnoP3:
                    'She has an iTop advanced certificate and masters the theory and practice of oral hygiene.',
                poklicnoP4:
                    'In the practice she ensures that work runs smoothly, that all tools are in their place and that everything is sterile, tidy and organized.',
                poklicnoP5:
                    'She kindly answers emails and calls, schedules appointments and answers all questions.',
                quote: 'During procedures she checks whether the patient is comfortable, whether they have any doubts or concerns, and encourages them. She knows the best tricks to stop water running down your throat during treatments. Literally!',
                osebnoTitle: 'Personal',
                osebnoP1:
                    'She is a partner, mother of two children, a school-age girl and a kindergarten boy.',
                osebnoP2:
                    'In her spare time she dedicates much attention to outdoor activities and spending time with children. They also enjoy watching performances and visiting the library.',
                osebnoP3:
                    'She spent her youth in Črnomelj, and now lives near Metlika, where she knows every corner along the Kolpa river.',
                osebnoP4: 'She loves baking something sweet and delicious.',
                osebnoP5: 'Katja also has not a single filling in her mouth.',
                zanimivostiTitle: '3 fun facts',
                zanimivosti1: 'Katja only likes green bananas',
                zanimivosti2: 'She cannot whistle',
                zanimivosti3Quote: '"Sočutno zobozdravstvo, how can I help you?"',
                zanimivosti3: 'Sometimes she accidentally answers a personal phone call with: {quote}',
            },
            mediaTitle: 'Media appearances',
            media: {
                rtv1SvetovalniServis: 'National Radio - Advisory Service',
                rtv1Title: 'What is proper oral health care?',
                rtv1SvetovalniDescription:
                    'The main call-in show with experts in the fields of healthcare, law, finance, ...',
                aktivniService: 'Podcast Aktivni (Active)',
                aktivniTitle: 'Dr. Urška Šavli: There is no healthy body without this',
                aktivniDescription: 'A podcast about inspiring stories of active people',
                sreckaService: 'Podcast Srečka (Lucky)',
                sreckaTitle: 'Dental health has a greater impact on your wellbeing than you think',
                sreckaDescription: 'A podcast that explores topics related to improving quality of life',
                rtv2Title: 'Oral health',
                ogledaloService: 'Podcast Ogledalo (Mirror)',
                ogledaloTitle: 'What do mental health and dental health have in common?',
                ogledaloDescription: 'A podcast about psychology, mindset and personal growth',
                poslusamSeService: 'Podcast and (Listening)',
                poslusamSeTitle: "Children's teeth from A to Z",
                poslusamSeDescription:
                    'Conversations with experts on child development and upbringing topics',
                rtvTitle3: 'World Oral Health Day - Oral hygiene',
                vasKanalService: 'Vaš kanal',
                vasKanalTitle: 'Workshop on oral health for seniors',
                vasKanalDescription:
                    'A news report on the ZZZS "Oral Health" workshops for different age groups',
            },
        },
        cenik: {
            title: 'Price List',
            back: 'Back',
            validFrom: 'The price list is valid from 1st November 2024.',
            vatNote: 'VAT is not charged in accordance with Article 94(1) of the VAT Act.',
            splosno: 'General',
            splosnoPregled: 'Dental check-up',
            splosnoPregledOtroci: 'Dental check-up for children',
            sploslnoPosvet: 'Consultation with the dentist',
            splosnoPosvetnMin: '15 minutes',
            sploslnoPredpisovanje: 'Prescribing medicine',
            splosnoNapotnica: 'Writing a referral or findings',
            splosnoOtrokNePusti: 'The child does not allow the procedure',
            splosnoOtrokNePustiMin: 'every 15 minutes',
            splosnoManjsiPoseg: 'Minor procedure',
            splosnoManjsiPosegMin: 'up to 10 minutes',
            splosnoSrednji: 'Intermediate procedure',
            splosnoZahteven: 'Complex procedure',
            rentgen: 'X-ray',
            rentgenOrtopan: 'Panoramic radiography',
            preventiva: 'Prevention',
            preventivaSonicno: 'Sonic tartar removal + polishing',
            preventivaPeskanje: 'Sandblasting',
            preventivaPeskanjeNaC: 'per jaw',
            preventivaScetkaPoliranje: 'Brushing and polishing',
            preventivaScetkaPoliranjeNaC: 'per jaw',
            preventivaFluoridi: 'Topical application of fluorides',
            preventivaFisure: 'Fissure sealing',
            preventivaFisureNaZ: 'per tooth',
            preventivaPouk: 'Oral hygiene instruction, plaque control with dye, and instructions',
            preventivaSDF: 'coating',
            preventivaSdfNaZ: 'single-tooth/multi-tooth',
            preventivaGluma: 'Anti-sensitivity coating',
            preventivaGlumaNaK: 'per quadrant',
            zobneBolezni: 'Dental diseases',
            zobneBolezniMajhnaZ: 'Small filling',
            zobneBolezniSrednjaZ: 'Medium filling',
            zobneBolezniVelikaZ: 'Large filling',
            zobneBolezniMlecniZ: 'Deciduous tooth filling',
            zobneBolezniMlecniZTip: 'simple/multilayer',
            zobneBolezniDograditev: 'Tooth bonding',
            zobneBolezniInjekcijska: 'Injection technique',
            zobneBolezniInjekcijskaOpis: 'bonding with liquid composite via silicone key (per tooth)',
            zobneBolezniBruksizem: 'Bruxism (Michigan) splint',
            estetika: 'Aesthetic dentistry',
            estetikaDomace: 'Whitening at home Opalescence GO',
            estetikaDomaceIndividualno: 'Whitening at home with individual splints',
            estetikaDomaceLasersko: 'In-office laser whitening',
            estetikaNots: 'Internal whitening of a stained tooth per session',
            estetikaIcon: 'Removal of white spots on teeth (ICON)',
            estetikaIconOpis: 'on two / three / more than three teeth',
            esteitikaBisercek: 'Aesthetic tooth gem',
            endodontija: 'Root canal treatment',
            endodontijaPolnitev: 'Root canal filling',
            endodontijaPolnitevEnok: 'Single-rooted tooth filling',
            endodontijaOdstranjevanje: 'Removal of old filling by machine spreading',
            endodontijaOdstranjevanjeNaK: 'per canal',
            endodontijaMenjava: 'Changing medicine',
            endodontijaMenjavaPerK: 'per canal',
            endodontijaStrojno:
                'Machine spreading, canal irrigation <small>per canal</small>, use of apex locator',
            endodontijaKritje: 'Direct/indirect pulp covering',
            endodontijaKritjeDod: 'surcharge',
            endodontijaZacasna: 'Temporary filling',
            endodontijaTrepanacija: 'Drilling into the pulpal canal',
            endodontijaToksavit: 'Drilling into the pulpal canal through the crown',
            lasersko: 'Laser dentistry',
            laserskoParodontalno: 'Periodontal treatment with laser',
            laserskoParodontalnoPolUst: 'half of the mouth',
            laserskoFrenulotomija: 'Frenulotomy',
            laserskoFrenulotomijaOpis: 'exam + procedure',
            laserskoFrenulotomijaSamo: 'Frenulotomy exam',
            laserskoFrenulotomijaSamoOpis: 'exam without procedure',
            laserskoManjsi: 'Minor laser procedure',
            laserskoBeljenje: 'In-office laser whitening',
            fiksnaProtetika: 'Fixed prosthetics',
            fiksnaProtetikaKovinskoKer: 'Metal-ceramic crown or pontic',
            fiksnaProtetikaKovinskoKerNaE: 'per unit',
            fiksnaProtetikaPolnoPor: 'Full ceramic crown or pontic',
            fiksnaProtetikaPolnoPorNaE: 'per unit',
            fiksnaProtetikaInlay: 'Inlay, onlay, endo crown - composite',
            fiksnaProtetikaInlayKer: 'Inlay, onlay, endo crown - ceramic',
            fiksnaProtetikaLuska: 'Zirconia or ceramic aesthetic veneer',
            fiksnaProtetikaFRC: 'FRC post',
            fiksnaProtetikaZacasna: 'Temporary crown - PMMA',
            fiksnaProtetikaZacasnaNaZ: 'per tooth',
            snemnaProtetika: 'Removable prosthetics',
            snemnaProtetikaTotalna: 'Complete denture',
            snemnaProtetikaDelnaZac: 'Partial acrylate denture',
            snemnaProtetikaDelnaVizil: 'Partial denture (metal)',
            snemnaProtetikaPodlozitev: 'Denture lining or repair',
            snemnaProtetikaFolija: 'Temporary foil with tooth to replace missing tooth',
            kirurgija: 'Surgery',
            kirurgijaEkstrakcija: 'Tooth extraction',
            kirurgijaEkstrakcijaTip: 'single-rooted/multi-rooted',
            kirurgijaKomplicirana: 'Complicated tooth extraction',
            kirurgijaAnestezija: 'Local anaesthesia',
            kirurgijaMlecni: 'Simple deciduous tooth extraction',
            kirurgijaMlecniTip: 'single-rooted/multi-rooted',
            kirurgijaLaser: 'Laser procedure',
            ortodontija: 'Orthodontics',
            ortodontijaMyobrace: 'Myobrace splint',
            ortodontijaMyobracePlus: '+ 5 monthly check-ups + follow-ups and exercises',
            ortodontijaMyobrace3: 'Myobrace level 3 splint',
            ortodontijaMyobraceIzg: 'Myobrace splint',
            ortodontijaMyobraceIzgOpis: 'lost or destroyed',
            ortodontijaLipTrainer: 'Lip trainer / MYOchew ',
            ortodontijaFroggy: ' device + 3 check-ups',
            ortodontijaInvisalignFirst: 'Invisalign First',
            ortodontijaInvisalignExpress: 'Invisalign Express',
            ortodontijaInvisalignExpressNaC: 'one jaw/both jaws',
            ortodontijaInvisalignLite: 'Invisalign Lite',
            ortodontijaInvisalignLiteNaC: 'one jaw/both jaws',
            ortodontijaInvisalignModerate: 'Invisalign Moderate',
            ortodontijaInvisalignModerateNaC: 'one jaw/both jaws',
            ortodontijaInvisalignComprehensive: 'Invisalign Comprehensive',
            ortodontijaInvisalignComprehensiveNaC: '3 years/5 years',
            ortodontijaInvisalignVivera: 'Invisalign Vivera splints',
            parodontologija: 'Periodontology',
            parodontologijaOpornica: 'Glass-fibre-reinforced periodontal splint',
            parodontologijaZdravljenje: 'Periodontal treatment',
            parodontologijaLaser: 'Periodontal laser treatment',
            parodontologijaLaserDod: 'surcharge',
            izdelki: 'Product sales',
            izdelkiScetka: 'Toothbrush',
            izdelkiScetkaOpis: 'Kids / Baby / 5460 / Solo',
            izdelkiPasta: 'Toothpaste <b>Curasept sensitive</b> / perio gel',
            izdelkiScetka3pack: 'Set of 3 toothbrushes <b>CS 5460 3pack</b>',
            izdelkiUstnaVoda: '<b>Curasept</b> Mouthwash',
            izdelkiPastaKids: '<b>Curaprox kids</b> Kids Toothpaste',
            izdelkiPastaKidsOpis: 'Strawberry or Mint',
            izdelkiFluorprotector: '<b>Fluorprotector</b> gel',
            izdelkiMI: 'GC MI Paste Plus / GC Tooth Mousse',
        },
    },
    router: {
        home: 'Sočutno Dentistry',
        cenik: 'Sočutno Dentistry - Price List',

        oNas: 'Sočutno zobozdravsto - About us',
        oNasDescription:
            'Dental clinic in Črnomelj. We offer dental services for children and adults with a compassionate, gentle, and thoughtful approach and professional expertise. Services include invisible orthodontic appliances Invisalign, Myobrace splints, periodontology, endodontics, surgery, aesthetic dentistry, pediatric dentistry, frenulotomy, teeth whitening. We focus on orthodontic treatment with Invisalign and Myobrace appliances in our practice.',

        pregledi: 'Sočutno Dentistry - Dental Check-Ups',
        karies: 'Sočutno Dentistry - Caries Treatment',
        ortopan: 'Sočutno Dentistry - Panoramic Radiography',
        beljenje: 'Sočutno Dentistry - Teeth Whitening',
        parodontologija: 'Sočutno Dentistry - Periodontology',
        otrosko: 'Sočutno Dentistry - Dental Care for Children',
        myobrace: 'Sočutno Dentistry - Myobrace',

        invisalignTitle:
            'Invisalign Price - How Much Do Invisalign Invisible Braces Cost - Sočutno Dentistry',
        invisalignDesc:
            'The price of Invisalign appliances depends on the number of splints and the condition of your teeth. Check the price of the Invisalign appliance. We are among the leading Invisalign providers in the region.',

        laserTitle:
            'Laser Dentistry - Periodontal Treatment, Surgery, Tissue and Gum Reshaping, Whitening - Sočutno Dentistry',
        laserDesc:
            'Lasers are excellent at removing bacteria, which is particularly important in long-term canal infections (gangrene). After laser disinfection of the canal, the tooth is more likely to heal successfully. The laser is used to cut or reshape gums or tissues in the mouth almost painlessly. After the laser procedure, conventional surgical suturing is not necessary. It is most effective in the treatment of periodontal disease. In the long term, combined laser treatment is much more successful than treatment with mechanical methods alone.',

        frenulotomijaTitle: 'Laser Frenulotomy - Tongue Frenulum Release - Sočutno Dentistry',
        frenulotomijaDesc:
            'Frenulotomy is a procedure in which the too-short ligaments in the mouth are cut. The procedure is performed using a laser. It is a safe, quick, and almost painless procedure.',

        protetikaTitle: 'Dental Prosthetics - Bridges, Crowns, Veneers - Sočutno Dentistry',
        protetikaDesc:
            'Modern top-quality dental prosthetics without waiting lists. Fabrication of metal-ceramic, full ceramic, and zirconia bridges, crowns, and veneers.',

        endodontsko: 'Sočutno Dentistry - Endodontic Treatment',

        injekcijskaTehnikaTitle:
            'Injection Technique - Composite Bonding Without Drilling - Sočutno Dentistry',
        injekcijskaTehnikaDesc:
            'The injection technique reshapes, resizes, and recolours teeth using a liquid GC composite material applied without drilling. Ideal for closing gaps between teeth, rebuilding worn teeth, and improving your smile.',

        admin: 'Sočutno admin',
    },
}
